import React, { Component } from "react";
import PacCronicos from "./PacCronicos";
import PacDiabetes from "./PacDiabetes";
import PacHipertension from "./PacHipertension";
import PacObesidad from "./PacObesidad";

export default class PanelPacCronicos extends Component {

  render() {
 
    const {unidad_medica_user}= this.props;

    return(
      
      unidad_medica_user !== "" &&
      <div className="grid-container-fvg">
      <div className="grid-item-fvg">
        <span className="format-titles-pnl">Pacientes con enfermedades crónicas</span>  
        <PacCronicos {...this.props}/>
        {/* <span className="pnl-format-pie">Años</span>   */}
      </div>
      <div className="grid-item-fvg">  
        <span className="format-titles-pnl">DIABETES</span>  
        <PacDiabetes {...this.props}/>
        <div className="container-square">
          <div className="square_diabetes_pnl">
          </div>
          <span className="pnl-format-pie">Pacientes</span>  
        </div> 
      </div>
      <div className="grid-item-fvg">
        <span className="format-titles-pnl">HIPERTENSIÓN</span>  
        <PacHipertension {...this.props}/>
        <div className="container-square">
          <div className="square_hipertension_pnl">
          </div>
          <span className="pnl-format-pie">Pacientes</span>  
        </div> 
      </div>
      <div className="grid-item-fvg">
        <span className="format-titles-pnl">OBESIDAD</span>
        <PacObesidad {...this.props}/>
        <div className="container-square">
          <div className="square_obesidad_pnl">
          </div>
          <span className="pnl-format-pie">Pacientes</span>  
        </div>
      </div>
    </div>
    );    
  }
}
